module.exports = __webpack_public_path__ + "media/post-listing-block-5-image@2x.70b3e3b6.webp";